import React, {Component, Fragment}  from 'react'
import { translate, Trans } from "react-i18next";
import PropTypes from 'prop-types'
import {Link} from 'react-router-dom';
import {get} from "../../../server/actions";

import NotificationSystem from 'react-notification-system';
import {_addNotification,_addNotificationError} from '../../../server/util';

import {BeatLoader} from 'react-spinners';
import ReactTable from 'react-table'
import SchoolMealProgramView from '../../SchoolAdmin/SchoolMealProgram/schoolMealProgramView';

const data={
    name: "student one",
    status: 5,
    grade : "Reduced",
    eligibility : 3,

}

class MealBenifitsApplicationView extends Component {
    constructor(props) {
        super(props)
        this.state={
            loading:false,
            applicationData: null,
            initStep:0,
            sid:"",
            schoolObject:{},
            appid:1
           
        }
    }
    componentWillMount=()=>{
        const {schoolObject,sid,appid} = this.context.router.route.location.state;
        console.log(schoolObject,sid)
       
        this.setState({sid,schoolObject,appid})
    }
    componentDidMount=()=>{
        this._notificationSystem = this.refs.notificationSystem;
        this.getAllApplications()
    }
    getAllApplications=(type)=>{
        console.log(type)
        if(type==="cancel"){
            this.props.history.push('/parent/mealbenifitsapplications',{schoolObject:this.state.schoolObject,sid:this.state.sid});
        }
        this.setState({ loading: true });
       // const suchoolYearValue = this.state.schoolObject.sessionYear.schoolYearValue
        get('/getHouseholdAppById?applicationId=' + this.state.appid + '&access_token=')
        .then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            
            this.setState({applicationData:data, loading: false });
        }).catch(
                (error) => {
                    this.setState({ loading: false })
                    console.log('Get School data response', error)
                }
            );
        }

    render (){
        const { t, i18n } = this.props;
        const changeLanguage = lng => {
            i18n.changeLanguage(lng);
          };
         
        return (
            <div>
                <NotificationSystem ref="notificationSystem"/>                
                    <section className=" full-width clearfix margin-top">
                        <div className='sweet-loading' style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000'}}>
                            <BeatLoader
                                size={20}
                                color={'#ea7066'}
                                loading={this.state.loading}
                            />
                        </div>
                        <div className="container" style={{height:'calc(100vh - 140px)'}}>
                            <div className='row'>
                                <div className='col-xs-12 col-sm-12 col-md-2 pull-right'>
                                    <label ><Trans>Language</Trans> :</label>
                                    <select className='form-control form-control-sm' value={i18n.language} onChange={(e)=>{
                                        if((e.target.value||'')==''){
                                            changeLanguage('en');
                                        }
                                        else{
                                            changeLanguage(e.target.value);
                                        }
                                    }}>
                                        <option value={'en'}>English</option>
                                        <option value={'es'}>Spanish</option>
                                    </select>
                                </div>
                            </div>
                         <br/>
                            <div className="container">
                        <div className="row">
                            <div className="col-md-12" id={'app'+this.state.appid}>
                                {this.state.applicationData &&   <SchoolMealProgramView id={this.state.appid}  appData={this.state.applicationData}
                                    refNotify={this} onSubmitChanges={()=>{
                                        const {schoolObject,sid,appid} = this.context.router.route.location.state;
                                        this.context.router.history.push({
                                            pathname: '/parent/mealbenifitsapplications',
                                            state: {
                                                schoolObject:schoolObject,
                                                sid:sid
                                            }});
                                    }}
                                    saveButtonLable={t('Save')}
                                    cancelButtonLable={t('Close')} isAdmin={false}/>                                                     
                            }
                              
                            </div>

                        </div>

                        </div>
                        </div>
                        
                    </section>
            </div>
        )
    }
}


MealBenifitsApplicationView.contextTypes = {
    router: PropTypes.object.isRequired
}

export default translate("translations")(MealBenifitsApplicationView);


// WEBPACK FOOTER //
// ./src/components/Parent/SchoolMealBenifitsApplications/mealBenifitsApplicationView.jsx